// extracted by mini-css-extract-plugin
module.exports = {"body-text":"monte-trial-class-introduction_body-text__4z3yU","content-wrapper":"monte-trial-class-introduction_content-wrapper__lRTPp"};